<div>
    <div class="fas fa-cog open-close-icon" id="fa-gear-icon"></div>
    <div class="open-close-icon" id="open-close-icon" (mouseover)="mouseOverGearIcon()" (mouseout)="mouseOutGearIcon()" (click)="toggleExpandClicked()"></div>
    <div class="legacy-pop-icon" id="legacy-pop-icon" (mouseover)="mouseOverLegacyPop()" (mouseout)="mouseOutLegacyPop()" (click)="legacyPopClicked()" *ngIf="!!legacyPopLink"></div>
</div>

<div id="dev-tools-hover" class="hover-subtext">
    Click to open/close developer tools. This will only show in non-production environments.
</div>

<div id="legacy-pop-hover" class="hover-subtext">
    Click to open this page in legacy POP. Destination: {{legacyPopLink}}
</div>

<div id="dev-tools-content" class="dev-tools-content">
    <ul ngbNav #devToolsNav="ngbNav" [(activeId)]="activeDevToolsTab" class="nav-tabs">
        <li [ngbNavItem]="1">
            <button type="button" ngbNavLink><span class="fas fa-list" aria-hidden="true"></span>&nbsp;Environment Config</button>
            <ng-template ngbNavContent>
                <div>
                    <span><span class="environment-config-text">{{environmentName}}</span> environment config settings</span>
                    <div class="environment-config-container">
                        <div class="table-responsive dev-tools-table-container">
                            <table class="table table-sm table-striped table-bordered">
                                <thead>
                                    <tr><th scope="col">Setting</th><th scope="col">Value</th></tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of environmentConfigData">
                                        <th scope="row">{{item.setting}}</th>
                                        <td>{{item.value}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2">
            <button type="button" ngbNavLink><span class="fas fa-key" aria-hidden="true"></span>&nbsp;Auth</button>
            <ng-template ngbNavContent>
                <div *ngIf="!user || (!!user && !user.authenticated)">
                    User is not authenticated.
                </div>
                <div *ngIf="!!user && user.authenticated">
                    <span class="jwt-claims-text">JWT claims for:</span>
                    <select class="form-select jwt-dropdownlist"
                        [(ngModel)]="selectedClaimDataDropdownItem"
                        (ngModelChange)="claimDataValueChange($event)">
                        <option *ngFor="let dataItem of claimDataDropdownItems" [ngValue]="dataItem">
                            {{dataItem.resourceName}} - {{dataItem.endpoint}}
                        </option>
                    </select>
                    <span class="adal-disabled-text" *ngIf="!useAdalAuth">NOTE: useAdalAuth is disabled in environment config (no endpoints shown)</span>
                    <div>
                        <input type="text" class="bearer-token-input" aria-label="Bearer token" readonly value="{{selectedEndpointBearerToken}}"/>
                    </div>
                    <div class="claims-grid-container">
                        <div class="table-responsive claims-table-container">
                            <table class="table table-sm table-striped table-bordered">
                                <thead>
                                    <tr><th scope="col">Claim</th><th scope="col">Value</th></tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let claim of selectedClaimDataDropdownItem.claims">
                                        <th scope="row">{{claim.claimKey}}</th>
                                        <td>{{claim.value}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="3">
            <button type="button" ngbNavLink><span class="fas fa-database" aria-hidden="true"></span>&nbsp;Metadata</button>
            <ng-template ngbNavContent>
                <div>
                    <div class="metadata-text">Metadata</div>
                    <pre>{{miscUtil.prettifyJson(pageMetadataState.displaySections)}}</pre>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="4">
            <button type="button" ngbNavLink><span class="fab fa-wpforms" aria-hidden="true"></span>&nbsp;Mock data</button>
            <ng-template ngbNavContent>
                <div *ngIf="!useLocalMockData">
                    <div>Not configured to use local mock data.</div>
                </div>
                <div *ngIf="useLocalMockData">
                    <div>
                        <div class="mock-data-text">Choose mock data:</div>
                        <select class="form-select mock-data-dropdownlist"
                            [(ngModel)]="selectedMockDataDropdownItem"
                            (ngModelChange)="mockDataValueChange($event)">
                            <option [ngValue]="mockDataNothingSelected">{{mockDataNothingSelected.description}}</option>
                            <option *ngFor="let dataItem of mockDataDropdownItems" [ngValue]="dataItem">{{dataItem.description}}</option>
                        </select>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="devToolsNav" class="dev-tools-tab-content"></div>
</div>
